import {
  ORG_AMENITY_KEYS,
  ORG_AMENITY_LABELS,
  type OrgAmenityKey,
} from '@court-sync/shared';
import { DashboardDataCard } from '@/components/dashboard/DashboardSectionCard';
import { SelectableCard } from '@/components/onboarding/SelectableCard';

interface OrgAmenitiesSettingsSectionProps {
  selected: OrgAmenityKey[];
  onChange: (next: OrgAmenityKey[]) => void;
  disabled?: boolean;
}

export function OrgAmenitiesSettingsSection({
  selected,
  onChange,
  disabled = false,
}: OrgAmenitiesSettingsSectionProps) {
  const selectedSet = new Set(selected);

  const toggle = (key: OrgAmenityKey) => {
    if (disabled) return;
    if (selectedSet.has(key)) {
      onChange(selected.filter((item) => item !== key));
      return;
    }
    onChange([...selected, key]);
  };

  return (
    <DashboardDataCard
      title="Amenities"
      description="Select amenities shown on your public site sidebar. Visitors use these to understand what your facility offers."
      contentClassName="px-4 py-5 sm:px-6"
    >
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" role="group" aria-label="Facility amenities">
        {ORG_AMENITY_KEYS.map((key) => (
          <SelectableCard
            key={key}
            id={`org-amenity-${key}`}
            title={ORG_AMENITY_LABELS[key]}
            selected={selectedSet.has(key)}
            disabled={disabled}
            selectionMode="multiple"
            onSelect={() => toggle(key)}
            className="w-full"
          />
        ))}
      </div>
    </DashboardDataCard>
  );
}
